import * as types from "./types";
import axios from "../../../common/config/axios";

export const getMemberProgress = () => (dispatch) => {
  axios
    .get("daily_check_in/member_progress")
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_MEMBER_PROGRESS,
        payload: res,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const checkIn = (data) => (dispatch) => {
  axios
    .post("daily_check_in/check_in", data)
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_CHECK_IN,
        payload: res,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getVipLevelRequirementAndReward = (props) => (dispatch) => {
  axios
    .get("daily_check_in/vip_level_requirement_and_reward", {params: props})
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_GET_VIP_LEVEL_REQUIREMENT_AND_REWARD,
        payload: res,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const clearProgress = () => (dispatch) => {
  axios
    .post("daily_check_in/clear_progress", {})
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_CLEAR_PROGRESS,
        payload: res,
      });
      // Re-fetch member progress after clearing
      getMemberProgress()(dispatch);
    })
    .catch((error) => {
      console.error(error);
    });
};

export const simulateCheckIn = (data) => (dispatch) => {
  axios
    .post("daily_check_in/simulate_check_in", data)
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_SIMULATE_CHECK_IN,
        payload: res,
      });
      // Re-fetch member progress after clearing
      getMemberProgress()(dispatch);
    })
    .catch((error) => {
      console.error(error);
    });
};
